import { createFileRoute } from "@tanstack/react-router";
import { InvitationPricePage } from "@/components/dashboard/invitation-price-page";

export const Route = createFileRoute("/invitation-price")({
  head: () => ({
    meta: [
      { title: "Invitation price — Deuxda Admin" },
      { name: "description", content: "Set the lowest and highest invitation price in diamonds." },
    ],
  }),
  component: () => <InvitationPricePage />,
});
